import { render } from "./SchemaBrickAttributeValueRelation.vue?vue&type=template&id=55dbca81"
import script from "./SchemaBrickAttributeValueRelation.vue?vue&type=script&lang=js"
export * from "./SchemaBrickAttributeValueRelation.vue?vue&type=script&lang=js"

import "./SchemaBrickAttributeValueRelation.vue?vue&type=style&index=0&id=55dbca81&lang=scss"
script.render = render

export default script